import { AoInstance } from "./ao"
import { getDataSource } from "../services/data-source"

export type SuggestedPool = {
  t1_name: string
  t0_name: string
  t0_process: string
  t0_ticker: string
  t1_ticker: string
  reserves_1: string
  tvl_in_usd: number
  reserves_0: string
  amm_process: string
  t1_process: string
}

export async function getSuggestedPools(tokenId: string, ao: AoInstance) {
  const dataSource = getDataSource(ao)
  const result = await dataSource.getPoolsForToken(tokenId)
  const overview = await dataSource.getPoolsOverview()

  // Collect every unique token to price
  const tokenSet = new Set<string>()
  result.forEach((p) => {
    tokenSet.add(p.token0_process)
    tokenSet.add(p.token1_process)
  })

  const suggestions = result.map<SuggestedPool>((p) => {
    const poolTVL = overview.find((o) => o.amm_process === p.amm_process)

    // Use liquidity_usd from pool data if available
    const tvl = poolTVL?.liquidity_usd ?? 0

    return {
      t0_name: p.token0_name,
      t1_name: p.token1_name,
      t0_ticker: p.token0_ticker,
      t1_ticker: p.token1_ticker,
      t0_process: p.token0_process,
      t1_process: p.token1_process,
      amm_process: p.amm_process,
      reserves_0: "0",
      reserves_1: "0",
      tvl_in_usd: tvl,
    }
  })

  suggestions.sort((a, b) => {
    if (a.tvl_in_usd == null && b.tvl_in_usd == null) return 0
    if (a.tvl_in_usd == null) return 1
    if (b.tvl_in_usd == null) return -1
    return b.tvl_in_usd - a.tvl_in_usd
  })

  return suggestions
}
